import React from "react";
import Button from "./Button";
import Translation from "../i18n";

class Answers extends React.Component {


    render() {

        const childs = this.props.question.children;
        const isMultiple = this.props.question.isMultiple;

        return (
            <>
                <div className="d-block my-4">
                    {this.props.question.children !== false &&
                        <>
                            {this.props.question.presentation === 'multipleAnswers' &&
                                childs.map((child, i) => (
                                    <div key={'answer' + i} className="answer">
                                        <Button

                                            question={{
                                                identifier: this.props.question.identifier,
                                                text: this.props.question.text
                                            }}

                                            answer={{
                                                identifier: child.identifier,
                                                value: child.text
                                            }}

                                            rating={{
                                                categories: child.categories,
                                                value: child.value
                                            }}

                                            childrenIdentifier={child.identifier}

                                            identifier={this.props.question.identifier} questionValue={this.props.question.text} id={this.props.question.identifier + i} isMultiple={isMultiple} updateSummary={this.props.updateSummary} setAnswered={this.props.setAnswered} >
                                            <span dangerouslySetInnerHTML={{__html: child.text.replace('<p>', '').replace('</p>', '')}} />
                                        </Button>
                                    </div>
                                ))
                            }
                        </>
                    }
                    {this.props.question.presentation === 'answer' &&
                        <>
                            <div className="answer">
                                <Button

                                    question={{
                                        identifier: this.props.question.identifier,
                                        text: this.props.question.text
                                    }}

                                    answer={{
                                        identifier: '1',
                                        value: '1'
                                    }}

                                    rating={{
                                        categories: this.props.question.categories,
                                        value: this.props.question.value
                                    }}

                                    identifier={this.props.question.identifier} questionValue={this.props.question.text} id={this.props.question.identifier + '1'} updateSummary={this.props.updateSummary} setAnswered={this.props.setAnswered} >
                                    <Translation i18n="yes" />
                                </Button>
                            </div>
                            <div className="answer">
                                <Button

                                    question={{
                                        identifier: this.props.question.identifier,
                                        text: this.props.question.text
                                    }}

                                    answer={{
                                        identifier: '0',
                                        value: '0'
                                    }}

                                    rating={{
                                        categories: this.props.question.categories,
                                        value: '0'
                                    }}

                                    identifier={this.props.question.identifier} questionValue={this.props.question.text} id={this.props.question.identifier + '0'} updateSummary={this.props.updateSummary} setAnswered={this.props.setAnswered} >
                                    <Translation i18n="no" />
                                </Button>
                            </div>
                        </>
                    }

                    {this.props.question.isMultiple &&
                        <span className="d-block answer-info-text">
                            <Translation i18n="answerInfoText1" />
                        </span>
                    }
                    {!this.props.question.isMultiple &&
                        <span className="d-block answer-info-text">
                            <Translation i18n="answerInfoText2" />
                        </span>
                    }
                </div>
            </>
        );
    }
}

export default Answers;
